// src/styles/typography.js
import { css } from 'styled-components';

export const typography = css`
  body {
    margin: 0;
    padding: 0;
    font-family: var(--font-family);
    background-color: var(--background-color);
    color: var(--text-color);
    font-size: var(--text-font-size);
  }

  h2 {
    font-size: var(--heading-font-size);
    color: var(--primary-color);

    @media (max-width: 768px) {
      font-size: 1.4rem;
    }

    @media (max-width: 480px) {
      font-size: 1.2rem;
    }
  }

  button {
    padding: var(--padding);
    border: none;
    border-radius: var(--border-radius);
    cursor: pointer;
    font-family: var(--font-family);

    @media (max-width: 768px) {
      padding: 0.6rem 1rem;
      font-size: 0.95rem;
    }
  }

  input {
    padding: var(--padding);
    border: 1px solid var(--text-color);
    border-radius: var(--border-radius);
    font-family: var(--font-family);
    font-size: var(--text-font-size);

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }

  input::placeholder {
    font-family: var(--font-family);
    font-size: var(--text-font-size);
    color: var(--text-color);
    opacity: 0.7;
  }
`;
